// extracted by mini-css-extract-plugin
export default {"container":"SuggestedEffect_container__1Dfis","body":"SuggestedEffect_body__b04-A"};